<template>
	<div
		class="skeleton"
		:class="computedClasses"
		:style="{
			width: width,
			height: height,
		}"
	></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	width: {
		required: false,
	},
	height: {
		required: false,
	},
	type: {
		type: String,
		default: 'custom',
	},
});

const Types = {
	input: {
		classes: 'tw-h-[45px] tw-rounded-lg',
	},
	button: {
		classes: 'tw-h-[40px] tw-rounded-lg',
	},
	text: {
		classes: 'tw-h-[25px] tw-rounded-md',
	},
};

const computedClasses = computed(() => {
	if (!Types[props.type]) return '';
	return Types[props.type].classes;
});
</script>

<style lang="scss" scoped>
.skeleton {
	animation: 1.2s loading ease-in-out infinite;
	background-color: rgb(234, 236, 240);
	background: linear-gradient(
			100deg,
			rgba(255, 255, 255, 0) 40%,
			rgba(255, 255, 255, 0.5) 50%,
			rgba(255, 255, 255, 0) 60%
		)
		rgb(234, 236, 240);
	background-size: 200% 100%;
	background-position-x: 180%;
}

@keyframes loading {
	to {
		background-position-x: -20%;
	}
}
</style>
